import React from 'react';


function ErrorBoundary(){
  return <p>Loading failed! Please reload.</p>;
}

export default ErrorBoundary;
